/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationReference } from './HomeHealthCertificationReference';
import {
    HomeHealthCertificationReferenceFromJSON,
    HomeHealthCertificationReferenceFromJSONTyped,
    HomeHealthCertificationReferenceToJSON,
    HomeHealthCertificationReferenceToJSONTyped,
} from './HomeHealthCertificationReference';

/**
 * 
 * @export
 * @interface HomeHealthCertificationSignature
 */
export interface HomeHealthCertificationSignature {
    /**
     * 
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     */
    method: HomeHealthCertificationSignatureMethodEnum;
    /**
     * 
     */
    signed_at: string;
    /**
     * 
     */
    signed_by: string;
    /**
     * 
     */
    ref: Array<HomeHealthCertificationReference>;
}


/**
 * @export
 */
export const HomeHealthCertificationSignatureMethodEnum = {
    Electronic: 'electronic',
    Handwritten: 'handwritten',
    Unknown: 'unknown',
} as const;
export type HomeHealthCertificationSignatureMethodEnum = typeof HomeHealthCertificationSignatureMethodEnum[keyof typeof HomeHealthCertificationSignatureMethodEnum];


/**
 * Check if a given object implements the HomeHealthCertificationSignature interface.
 */
export function instanceOfHomeHealthCertificationSignature(value: object): value is HomeHealthCertificationSignature {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('signed_at' in value) || value['signed_at'] === undefined) return false;
    if (!('signed_by' in value) || value['signed_by'] === undefined) return false;
    if (!('ref' in value) || value['ref'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationSignatureFromJSON(json: any): HomeHealthCertificationSignature {
    return HomeHealthCertificationSignatureFromJSONTyped(json, false);
}

export function HomeHealthCertificationSignatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationSignature {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'method': json['method'],
        'signed_at': json['signed_at'],
        'signed_by': json['signed_by'],
        'ref': ((json['ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
    };
}

export function HomeHealthCertificationSignatureToJSON(json: any): HomeHealthCertificationSignature {
    return HomeHealthCertificationSignatureToJSONTyped(json, false);
}

export function HomeHealthCertificationSignatureToJSONTyped(value?: HomeHealthCertificationSignature | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'method': value['method'],
        'signed_at': value['signed_at'],
        'signed_by': value['signed_by'],
        'ref': ((value['ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
    };
}

